import { load } from 'recaptcha-v3'

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY

export const useGoogleRecaptcha = () => {
    const getRecaptchaToken = async (action: string) => {
        const recaptcha = await load(RECAPTCHA_SITE_KEY, {
            autoHideBadge: true,
        })
        const token = await recaptcha.execute(action)
        return token
    }

    return { getRecaptchaToken }
}
